/**
 *
 * Asynchronously loads the component for ShoutOutPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShoutOutPage = lazyLoad(
  () => import('./index'),
  module => module.ShoutOutPage,
);
